import { COUNTRIES } from '@/services/countries'

export default {
  namespaced: true,
  state: {
    countries: COUNTRIES,
    countriesChoices: COUNTRIES.map((c) => {
      return { label: c.name, value: c.value }
    }),
  },
}
